import React, { useState } from "react";
import { Roles } from "../../roles.js";
import "../../styles/user/createuser.css";
import { useTranslation } from 'react-i18next';
import { useAuth } from "../context/AuthContext.jsx";
export default function CreateUser() {
    const [email, setEmail] = useState("");
    const [role, setRole] = useState(Roles.USER); // default role
    const [message, setMessage] = useState("");
    const [loading, setLoading] = useState(false);
    const { t } = useTranslation();
    const [isOpen, setIsOpen] = useState(false);
    const apiUrl = process.env.REACT_APP_OPT_SERVER || "http://localhost:8888";

    const { token } = useAuth();
    const [error, setError] = useState("");
    const clearErrorAfterDelay = () => {
        setTimeout(() => {
            setError("");
            setMessage("");
        }, 6000);
    };

    const handleCreateUser = async (e) => {
        e.preventDefault();

        // --- Client-side validation ---
        if (!email.trim()) {
            setError(t("err-email-empty"));
            clearErrorAfterDelay();
            return;
        }

        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(email.trim())) {
            setError(t("err-email"));
            clearErrorAfterDelay();
            return;
        }

        if (!role && role !== 0) {
            setError(t("err-role-empty")); // needs translation
            clearErrorAfterDelay();
            return;
        }

        setLoading(true);

        try {
            if (!token) throw new Error("No token found");

            const response = await fetch(`${apiUrl}/api/users/`, {
                method: "POST",
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    email,
                    role: parseInt(role),
                }),
            });

            if (!response.ok) {
                const errorData = await response.json().catch(() => ({}));

                // --- Handle specific case: user already exists ---
                if (response.status === 409 || /exists/i.test(errorData.error || "")) {
                    throw new Error(t("err-user-exists")); // needs translation key
                }

                throw new Error(errorData.error || `HTTP error ${response.status}`);
            }

            // const data = await response.json();

            setMessage(t("msg-user-created"));
            clearErrorAfterDelay();

            setEmail("");
            setRole(Roles.USER);
            setTimeout(() => {
                window.location.reload();
            }, 8000);
        } catch (error) {
            console.error("Create user error:", error.message);
            setError(error.message || t("err-otp-network"));
            clearErrorAfterDelay();
        } finally {
            setLoading(false);
        }
    };

    const handleEmailChange = (e) => {
        setEmail(e.target.value);
        if (error) setError("");
    };

    return (

        <div className="login-container">
            <div className="login-form">
                <form onSubmit={handleCreateUser}>

                    {message && (
                        <div
                            className="alert-box success"
                            role="alert"
                        >
                            <svg xmlns="http://www.w3.org/2000/svg" width="20px" height="20px" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M12 21a9 9 0 0 0 7.51-13.961l-7.155 7.95a2 2 0 0 1-2.687.262L6.4 12.8a1 1 0 0 1 1.2-1.6l3.268 2.451l7.346-8.161A9 9 0 1 0 12 21" clip-rule="evenodd" /></svg>
                            <span>{message}</span>
                            <button onClick={() => setMessage("")}>&times;</button>
                        </div>
                    )}

                    {error && (
                        <div
                            className="alert-box error"
                            role="alert"
                        >
                            <svg xmlns="http://www.w3.org/2000/svg" width="20px" height="20px" viewBox="0 0 24 24"><path fill="currentColor" d="M12 17q.425 0 .713-.288T13 16t-.288-.712T12 15t-.712.288T11 16t.288.713T12 17m0-4q.425 0 .713-.288T13 12V8q0-.425-.288-.712T12 7t-.712.288T11 8v4q0 .425.288.713T12 13m0 9q-2.075 0-3.9-.788t-3.175-2.137T2.788 15.9T2 12t.788-3.9t2.137-3.175T8.1 2.788T12 2t3.9.788t3.175 2.137T21.213 8.1T22 12t-.788 3.9t-2.137 3.175t-3.175 2.138T12 22" /></svg>
                            <span>{error}</span>
                            <button onClick={() => setError("")}>&times;</button>
                        </div>
                    )}

                    <div className="login-logo">
                        <img src="/assets/MPTC_Logo.png" alt="Logo" className="logo-image" />
                    </div>

                    <label className="login-label">
                        {t('user-label')}{" "}
                        <span className="required">*</span>
                    </label>

                    <input
                        type="text"
                        placeholder="e.g. bopha@gov.kh"
                        value={email}
                        onChange={handleEmailChange}
                        className={`login-input ${error ? "error" : ""}`}
                        disabled={loading}
                    />
                    <div className="select-wrapper">
                        <select
                            value={role}
                            onChange={(e) => setRole(Number(e.target.value))}
                            onFocus={() => setIsOpen(true)}   // open
                            onBlur={() => setIsOpen(false)}   // close
                        >
                            {Object.entries(Roles).map(([key, value]) => (
                                <option key={key} value={value}>
                                    {key.toUpperCase()}
                                </option>
                            ))}
                        </select>

                        <div className="icons">
                            {isOpen ? (

                                <svg className="icon up" xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24"><path fill="#374151" fill-rule="evenodd" d="M12.248 8.237a.25.25 0 0 0-.354 0L5.53 14.601a.75.75 0 1 1-1.06-1.06l6.363-6.364a1.75 1.75 0 0 1 2.475 0l6.364 6.364a.75.75 0 0 1-1.06 1.06z" clip-rule="evenodd" /></svg>

                            ) : (

                                <svg className="icon down" xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24"><path fill="#374151" fill-rule="evenodd" d="M4.47 9.4a.75.75 0 0 1 1.06 0l6.364 6.364a.25.25 0 0 0 .354 0L18.612 9.4a.75.75 0 0 1 1.06 1.06l-6.364 6.364a1.75 1.75 0 0 1-2.475 0L4.47 10.46a.75.75 0 0 1 0-1.06" clip-rule="evenodd" /></svg>

                            )}
                        </div>
                    </div>

                    <button type="submit" disabled={loading} className="login-button">
                        {loading ? t('registering') : t('register')}
                    </button>
                </form>
                <img src="/assets/Desktop_background.svg" alt="banner" className="desktop_banner" />
                <img src="/assets/Mobile_background.svg" alt="banner" className="mobile_banner" />
            </div>
        </div>

    );
}


